import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading || user === null) {
        return (
            <div
                className="min-h-screen flex items-center justify-center bg-[var(--crewz-bg)] text-zinc-500 font-body"
                data-testid="protected-route-loading"
            >
                <span className="overline">Loading the Crew…</span>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return children;
}
